'use strict';

const _=require('pulsar-utils/dist-es6/_');
const WaypointTypes=require('../../../dist-es6/client/domain/waypointTypes');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const SubmissionErrors={
DestinationTimeBeforeOriginTime:'Destination time cannot be before origin time.',
RouteInfeasible:'No feasible route found, did you leave enough time to travel between locations?',
ServiceUnreachable:'Routing service unreachable, please contact support.',
UnknownError:'Unknown error calculating route, please check form values and try again.',
InvalidWaypoints:'Waypoints cannot be validated, please check fields.'};let


TripPlanningService=class TripPlanningService extends BaseService{
static get $inject(){
return['drivePlanService','socketService'];
}

constructor(drivePlanService,socketService){
super();
this._drivePlanService=drivePlanService;
this._socketService=socketService;
}

async plan(personId,waypointInputs){
let errors=[];

let validatedWaypoints=await this._getValidatedWaypoints(waypointInputs,errors);
if(!_.exists(validatedWaypoints)){
errors.push(SubmissionErrors.InvalidWaypoints);
return{errors:errors};
}

let scenarioResponse=await this._drivePlanService.getAndInflateRouteScenario(personId,validatedWaypoints);

if(_.exists(scenarioResponse.status)){
if(scenarioResponse.status==='ROUTE_INFEASIBLE'){
errors.push(SubmissionErrors.RouteInfeasible);
return{errors:errors};
}else
if(scenarioResponse.status==='SERVICE_UNREACHABLE'){
errors.push(SubmissionErrors.ServiceUnreachable);
return{errors:errors};
}else
if(scenarioResponse.status!=='OK'){
errors.push(SubmissionErrors.UnknownError);
return{errors:errors};
}
}

return{
route:scenarioResponse.route,
queryInterval:scenarioResponse.queryInterval,
schedule:scenarioResponse.schedule};

}

async _getValidatedWaypoints(waypointInputs,errors){
let validatedWaypoints=[];

for(let input of waypointInputs){
let validatedAddress=await this._getValidatedAddress(input.address);

if(!validatedAddress.valid){
return null;
}

let latLong={
lat:validatedAddress.result.latitude,
long:validatedAddress.result.longitude};


let timeZone=await this._getTimezoneFromLocation(latLong);
let validatedTime=this._getValidatedTimeWithCorrectOffset(input.displayTime,timeZone);
let waypointTypeIsValid=this._validateWaypointType(input.waypointType);

if(!_.exists(validatedTime)||!waypointTypeIsValid){
return null;
}

validatedWaypoints.push({
address:validatedAddress.result.formattedAddress,
time:validatedTime,
type:input.waypointType.stopType});

}

let previousTime=_.head(validatedWaypoints).time;
for(let waypoint of _.tail(validatedWaypoints)){
if(waypoint.time<previousTime){
errors.push(SubmissionErrors.DestinationTimeBeforeOriginTime);
return null;
}
previousTime=waypoint.time;
}

return validatedWaypoints;
}

_isDateValid(dateToValidate){
return _.isDate(dateToValidate)&&!Number.isNaN(dateToValidate.getTime());
}

_getValidatedTimeWithCorrectOffset(displayTime,timeZone){
if(!this._isDateValid(displayTime)){
return null;
}
return pulsarDate(displayTime).fromLocalOffsetToOffsetOf(timeZone);
}

_validateWaypointType(type){
return _.includes(WaypointTypes.all,type);
}

async _getValidatedAddress(address){
return await this._socketService.sendAndWaitForResponse('ValidateAddress',address);
}

async _getTimezoneFromLocation(location){
return await this._socketService.sendAndWaitForResponse('GetTimezoneForLocation',location);
}};

module.exports=TripPlanningService;
//# sourceMappingURL=tripPlanningService.js.map
